// Constants shared by server, client, and tests.

export const FRAME_MAGIC: readonly [number, number] = [0x41, 0x53]; // "AS"
export const FRAME_VERSION = 1;
export const FRAME_HEADER_BYTES = 12;
export const PCM_BYTES_PER_SAMPLE = 2;
export const SAMPLE_RATE = 24_000;
export const MIC_FRAME_MS = 20;
export const MIC_SAMPLES = (SAMPLE_RATE * MIC_FRAME_MS) / 1000; // 480
export const MIC_BYTES = MIC_SAMPLES * PCM_BYTES_PER_SAMPLE; // 960
export const PROTOCOL_VERSION = 1;

export type FrameDirection = 1 | 2; // 1 = mic up, 2 = speaker down
export const DIR_MIC: FrameDirection = 1;
export const DIR_SPEAKER: FrameDirection = 2;